var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-whatsapp"},[_c('button',{staticClass:"whatsapp-icon"},[_c('a',{staticClass:"social whatsapp",attrs:{"href":_vm.whatsapp_link,"target":"_blank"}},[_c('b-icon',{attrs:{"icon":"whatsapp"}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }